import React from 'react';
import Image from 'next/image';

import Button from '@/lib/Button';
import SecuredByRazorpay from '@/lib/SecuredByRazorpay';

interface SuccessScreenProps {
  onCtaClick: () => void;
  ctaText: string;
  title: string;
  children?: React.ReactNode;
  topDescription: string;
  bottomDescription?: string;
  ctaLoading?: boolean;
  isFullScreen?: boolean;
}

const SuccessScreen: React.FC<SuccessScreenProps> = ({
  title,
  ctaText,
  onCtaClick,
  topDescription,
  bottomDescription,
  children,
  ctaLoading,
  isFullScreen,
}) => {
  return (
    <div className="d:w-70">
      <div className={isFullScreen ? 'overflow-scroll px-6 py-8 grow h-full d:p-0' : 'px-6'}>
        <div className={`flex flex-col items-center ${isFullScreen ? 'mt-[4rem] d:mt-0' : ''}`}>
          <h2 className="font-tasa font-semibold text-on-grey-normal text-2xl">{title}</h2>
          <p
            className={`font-medium text-on-grey-subtle text-lg text-center ${
              ctaLoading ? 'hidden' : ''
            }`}
          >
            {topDescription}
          </p>
          {children ? <div className="mt-3">{children}</div> : null}
          <Image className="my-10" width={175} height={100} src="/cash.svg" alt="Cash" />
          <p className="font-medium text-on-grey-subtle text-lg">{bottomDescription}</p>
        </div>
      </div>
      {ctaLoading ? (
        <div className="w-full flex flex-col items-center justify-center">
          <Image
            className="animate-spin my-0"
            src="/spinner.svg"
            alt="spinner"
            width={24}
            height={24}
          />
          <p className="mt-6 font-medium text-on-grey-subtle text-sm text-center">
            {topDescription}
          </p>
        </div>
      ) : (
        <div
          className={
            isFullScreen
              ? 'px-6 pt-2 pb-7 bg-white-normal shadow-top shrink-0 absolute bottom-0 d:relative w-full d:p-0 d:shrink-unset d:shadow-none'
              : ''
          }
        >
          <Button
            loadingText={ctaText}
            isLoading={ctaLoading}
            className="mt-0"
            onClick={onCtaClick}
          >
            {ctaText}
          </Button>
        </div>
      )}
    </div>
  );
};

export default SuccessScreen;
